import { InjectionToken } from '@angular/core';

export const CDN_URL = new InjectionToken<string>('cdn.url');
export const OPEN_AI = new InjectionToken<string>('openAi.url');
